export default __webpack_public_path__ + "static/media/section8-img1.ee494f96.png";